import { useContext, FC, useState, useEffect } from 'react'
import { Fade } from '@chakra-ui/react'
import { Socket, io } from 'socket.io-client'

import { INSTITUTION_WEB_SOCKET_URL } from 'constants/system'
import { Loader } from 'components'
import SocketConnectionManagerContext from './Context'

type Props = {
  children: JSX.Element
}

const SocketConnectionManagerProvider: FC<Props> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null)

  useEffect(() => {
    const socketConnection = io(INSTITUTION_WEB_SOCKET_URL, {
      transports: ['websocket'],
      withCredentials: true,
      reconnectionAttempts: 1,
    })

    setSocket(socketConnection)

    return () => {
      socketConnection.disconnect()
    }
  }, [])

  if (socket === null) {
    return <Loader text="Carregando conexão em tempo real" height="100vh" />
  }

  return (
    <SocketConnectionManagerContext.Provider value={{ socket }}>
      <Fade in>{children}</Fade>
    </SocketConnectionManagerContext.Provider>
  )
}

export const useSocketConnectionManager = () => useContext(SocketConnectionManagerContext)

export default SocketConnectionManagerProvider
